export default {
	GET_PAGE_LOADING: state => state.page.loading,
	GET_REGISTER: state => state.register,
	GET_PERSONAL_INFO: state => state.personalInfo,
	GET_RIBBON_NOTIFICATION: state => state.ribbonNotification,
	GET_MAIN_UI: state => state.mainUI,
	GET_LANDING_PAGE_CONTENT: state => state.landingPageContent,
	GET_FOOTER_SETTINGS: state => state.footerSettings,
    // GET_PAYMENT_API: state => state.paymentAPI,
	GET_SEARCHED_ADDRESSES: state => state.searchedAddresses,
	GET_ACTIVE_ADDRESS: state => state.activeAddress,
	GET_ACTIVE_FAVORITE: state => state.activeFavorite,
	GET_SERVICE_GROUP: state => state.serviceGroup,
    GET_SERVICE_GROUP_ADDRESS: state => state.serviceGroupAddress,
    GET_SERVICES_OF_SELECTED_SERVICE_GROUP: state => state.servicesOfSelectedServiceGroup,
    GET_EXCLUDED_SERVICES_OF_SELECTED_ADDRESS_SETTING: state => state.excludedServicesOfSelectedAddressSetting,
    GET_ENTITLEMENT_GROUP: state => state.entitlementGroup,
    GET_ENTITLEMENT_DETAILS: state => state.entitlementDetails,
    GET_SERVICES: state => state.services,
    GET_ADDRESS_ENTITLEMENT: state => state.addressEntitlement,
    GET_SERVER_DATE: state => state.getServerDate,
    GET_AVAILABLE_BOOKING_DATES_OF_ADDRESS: state => state.availableBookingDatesOfAddress,
    GET_ALL_WASTE_STREAMS: state => state.allWasteStreams,
    GET_WOI_WASTE: state => state.woiWasteTypes,
    GET_ACTIVE_SERVICE_GROUP: state => state.activeServiceGroup,
    GET_ACTIVE_SERVICE_SETTING: state => state.activeServiceSetting,
    GET_MULTIPLE_COLLECTION: state => state.multipleCollection,
    GET_REGISTER_CONFIRMATION: state => state.registerConfirmation,
    GET_RESEND_CONFIRMATION_EMAIL: state => state.resendConfirmationEmail,
    GET_PRICING: state => state.pricing,
    GET_ACTIVEFORM_INDEX: state => state.activeStepIndex,
    GET_BOOKING_PRODUCTS: state => state.selectedBookingProducts,
    GET_BOOKING_SUMMARY_DETAILS: state => state.bookingSummaryDetails,
    GET_BOOKING_STATE : state => state.bookingState,
    GET_BOOKING_ACKNOWLEDGE: state => state.bookingAcknowledged,
    GET_BOOKING_HISTORY_ADDRESS: state => state.bookingHistoryAddress,
    GET_BOOKING_SUBMISSION: state => state.bookingSubmission,
    GET_WASTE_COMBO: state => state.wasteStreamsCombo,
    GET_WASTE_COMBO_LIST: state => state.wasteStreamsComboList,
    GET_WEBSITE_METADATA : state => state.websiteMetadata,
    GET_MAX_STREAM_PRICE : state => state.maxStreamPrice,
    GET_IS_COLLECTION_WEEK_SHOWN : state => state.isCollectionWeekShown,
    GET_SITE_WORDINGS : state => state.siteWordingsSettings,
    GET_STREET_ABBREVIATIONS : state => state.streetAbbreviations,
}